const digest = '665fbc1d7e15b55e6b8b5915357e86398e44f0e343264fda5f0bb6448a9ee0e7';
const css = `.container{max-width:1024px!important}@media (max-width:1023px){._globalHeader_4hc2y_6{display:none}}._subnavSpaceUS_4hc2y_10{padding-top:.625rem}._subnavSpace_4hc2y_10{padding-top:3.625rem}@media (max-width:1023px){._subnavSpaceUS_4hc2y_10,._subnavSpace_4hc2y_10{padding-top:3.8rem}._advisory_4hc2y_24{position:relative;top:3.19rem}}@media (min-width:1023px){._advisory_4hc2y_24{margin-top:3.19rem}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'globalHeader': '_globalHeader_4hc2y_6', 'subnavSpaceUS': '_subnavSpaceUS_4hc2y_10', 'subnavSpace': '_subnavSpace_4hc2y_10', 'advisory': '_advisory_4hc2y_24' };
export const globalHeader = '_globalHeader_4hc2y_6';
export const subnavSpaceUS = '_subnavSpaceUS_4hc2y_10';
export const subnavSpace = '_subnavSpace_4hc2y_10';
export const advisory = '_advisory_4hc2y_24';
export { css, digest };